import React from 'react';
import { CameraOutline } from 'antd-mobile-icons';
import { Image, Space } from 'antd-mobile';
import {TransportPositionType} from "../services/TransportPhotoService";
import PickUpPhotoSelector from "../../pickup/components/PickUpPhotoSelector";

interface TransportPhotoUploadCardProps {
    photoUrl: string | null | undefined;
    type: TransportPositionType;
    description: string;
    onTakePhoto: (type: TransportPositionType, file: File) => void;
    onDelete: (type: TransportPositionType) => void;
    onView: (url: string) => void;
}

const TransportPhotoUploadCard: React.FC<TransportPhotoUploadCardProps> = ({
    photoUrl,
    type,
    description,
    onTakePhoto,
    onDelete,
    onView
}) => (
    <div className="aspect-square overflow-hidden bg-white w-full border border-gray-200 rounded-lg flex items-center justify-center">
        {photoUrl ? (
            <div className="relative h-full w-full">
                <Image
                    src={photoUrl}
                    alt={description}
                    fit="cover"
                    className="w-full h-full object-cover"
                    onClick={() => onView(photoUrl)}
                />
                <Space
                    className="absolute top-2 right-2 bg-black/60 px-2 py-1 rounded text-white"
                >
                    <span
                        className="text-xs cursor-pointer"
                        onClick={(e) => {
                            e.stopPropagation();
                            onDelete(type);
                        }}
                    >
                        X
                    </span>
                </Space>
            </div>
        ) : (
            <PickUpPhotoSelector
                onPhotoSelected={(file) => { onTakePhoto(type, file); }}
                buttonText={
                    <div
                        className="flex flex-col items-center cursor-pointer p-2"
                    >
                        <div className="text-3xl text-gray-400 mb-2">
                            <CameraOutline fontSize={48} />
                        </div>
                        <p className="m-0 text-gray-600 text-sm">{description}</p>
                    </div>
                }
            />
        )}
    </div>
);

export default TransportPhotoUploadCard;


